<div class="today-container">
  <button class="btn todayBtn" (click)="selectToday()">{{ 'WORKPLAN.TODAY' | translate }}</button>
</div>
<ngb-datepicker #dp [navigation]="'arrows'" (dateSelect)="onDateSelection($event)" [minDate]="{year: minYear, month: minMonth, day: minDay}" [(ngModel)]="date" [dayTemplate]="t" [firstDayOfWeek]="firstDayOfWeek" (navigate)="date = $event.next"></ngb-datepicker>

<ng-template #t let-date="date" let-selected="selected">
  <span class="custom-day" [class.selected-date]="selected">
    {{ date.day }}
  </span>
</ng-template>